import React, { Component } from 'react';
import Backdrop from '../../../../common/components/UI/Backdrop/Backdrop';
import { connect } from 'react-redux';

class backdropWrapper extends Component {
    render() {
        const { spinnerShow } = this.props
        return (
            <Backdrop
                showSpinner={spinnerShow}
                showBack={spinnerShow}
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        spinnerShow: state.spinnerShow
    }
}

export default connect(mapStateToProps)(backdropWrapper);